import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowThickRight2 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M.75,12.394A2.25,2.25,0,0,0,3,14.644H15.568L12.515,17.7A2.25,2.25,0,1,0,15.7,20.88l6.894-6.895a2.25,2.25,0,0,0,0-3.182L15.7,3.909a2.25,2.25,0,0,0-3.182,3.182l3.053,3.053H3A2.25,2.25,0,0,0,.75,12.394Z",
		fill: "var(--icon-color, currentColor)"
	})
});
export default SvgArrowThickRight2;
